module.exports = require('./../dist/svg-components/material/DirectionsCar');